import { motion } from "framer-motion";
import Manifesto from "@/components/Manifesto";
import Seo from "@/components/Seo";
import Testimonials from "@/components/Testimonials";
import StatsStrip from "@/components/StatsStrip";
import EditorialMarquee from "@/components/EditorialMarquee";
import QuoteForm from "@/components/QuoteForm";

export default function About() {
  return (
    <div data-testid="page-about">
      <Seo
        title="About Maze Security Solutions — Our Doctrine | NB"
        description="Founded 2008 in Fredericton. 150+ full-time officers, 400-person event surge roster, $5M insurance, bilingual, NB Class 2 licensed. The doctrine behind province-wide protection."
        path="/about"
      />
      <section className="pt-32 md:pt-40 pb-16 border-b border-border">
        <div className="mx-auto max-w-[1600px] px-6 md:px-12">
          <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-muted-foreground mb-6">
            [ About · The Doctrine ]
          </div>
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, ease: [0.76, 0, 0.24, 1] }}
            className="font-serif font-light text-5xl md:text-9xl leading-[0.9] tracking-tighter"
          >
            The doctrine behind <br />
            <i className="text-primary">province-wide protection.</i>
          </motion.h1>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mt-16">
            <div className="md:col-span-7 space-y-6">
              <p className="text-lg md:text-xl leading-relaxed text-foreground/85">
                Founded in Fredericton in 2008, New Brunswick Security Services
                has grown from a two-officer mobile patrol company into the
                province's most trusted protection provider — delivering
                licensed security across every incorporated community in New
                Brunswick — from Woodstock to Caraquet.
              </p>
              <p className="text-base md:text-lg leading-relaxed text-foreground/75">
                We were built on a single conviction: the security industry in
                Atlantic Canada deserved something better than clipboard-and-flashlight
                minimum-wage guarding. Our founders — a former RCMP sergeant and
                a Canadian Armed Forces logistics officer — designed the
                training program, licensing pipeline, dispatch platform and
                compensation structure that continues to distinguish our teams
                today.
              </p>
              <p className="text-base md:text-lg leading-relaxed text-foreground/75">
                Every officer we deploy is provincially Class 2 licensed, First
                Aid / CPR certified, background screened at Level 2 (RCMP CPIC),
                and drilled monthly against the same protocol library. Our
                dispatch operates 24/7/365. Our supervisors ride nights. Our
                incident reports are court-ready.
              </p>
              <p className="text-base md:text-lg leading-relaxed text-foreground/75">
                Bilingual by design, ethical by policy, and technological by
                necessity — this is what a modern New Brunswick security
                partner looks like.
              </p>
            </div>
            <aside className="md:col-span-5">
              <div className="border border-border p-8 bg-[hsl(0_0%_6%)] space-y-6 font-mono text-xs tracking-widest">
                {[
                  ["Founded", "2008 · Fredericton"],
                  ["Roster", "150+ full-time · 400 event surge"],
                  ["Insurance", "$5M CGL · $5M E&O"],
                  ["Bilingual", "40% English / French"],
                  ["Response", "4h province-wide"],
                  ["Coverage", "60+ communities"],
                  ["License", "NB Class 2 · Business"],
                  ["Insurance", "WorkSafeNB compliant"],
                ].map(([k, v]) => (
                  <div
                    key={k}
                    className="flex justify-between items-start border-b border-border pb-3"
                  >
                    <span className="text-muted-foreground uppercase">{k}</span>
                    <span className="text-right">{v}</span>
                  </div>
                ))}
              </div>
            </aside>
          </div>
        </div>
      </section>

      <StatsStrip />
      <Manifesto />
      <EditorialMarquee />
      <Testimonials />
      <QuoteForm />
    </div>
  );
}
